<template>
  <div>
    <cool-preview :data-id="showPreview" data-type="notifications" v-if="showPreview"></cool-preview>
  </div>
</template>

<script>
const setCookie = (cname, cvalue, exdays) => {
  let d = new Date()
  d.setTime(d.getTime() + (exdays*24*60*60*1000))
  let expires = "expires="+ d.toUTCString()
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}
const getCookie = (cname) => {
  let name = cname + "="
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
  }
import moment from 'moment'
import {fetchNotifications} from '@/services/contentService'
import coolPreview from '@/components/coolPreview.component'
export default {
  name: 'notificationComponent',
  components: {
    coolPreview
  },
  props: {},
  data () {
    return {
      showPreview: false,
      empty:true,
      notices: []
    }
  },
  mounted () {
    this.$_getItems()
  },
  computed:{
    currentNotice:{
      get () {
        return this.notices.length > 0 
        ? this.notices[0]
        : false
      }
    }
  },
  methods: {
    $_NewCheck() {
      if (this.notices.length < 1 ) return
      let showNoticeOn = this.currentNotice.acf.show_on
      const homeScreen = window.location.pathname === '/'
      let hasSeen = getCookie('addID') ? getCookie('addID') : false
      
      let fromDate = moment(new Date(this.currentNotice.acf.show.from))
      let toDate = moment(new Date(this.currentNotice.acf.show.to))
      let today = moment(new Date())
      let dateRange = moment(today).isBefore(toDate) && moment(today).isAfter(fromDate)
      
      if(!dateRange) {
          return
      }

      if (hasSeen && homeScreen && showNoticeOn === 'Home Page') {
        if (parseInt(hasSeen) === this.currentNotice.id && this.currentNotice.acf.frequency === 'every') {
          this.showPreview = this.currentNotice.id
        } else if (parseInt(hasSeen) !== this.currentNotice.id){
          this.showPreview = this.currentNotice.id
          setCookie('addID', this.currentNotice.id, 12)
        }
        return
      }
       else if(this.currentNotice.acf.frequency === 'every' && homeScreen && showNoticeOn === 'Home Page') {
        setCookie('addID', this.currentNotice.id, 12)
        this.showPreview = this.currentNotice.id
        return
      } else if (!hasSeen) {
        setCookie('addID', this.currentNotice.id, 12)
        this.showPreview = this.currentNotice.id
        return
      }

      if(showNoticeOn === 'Site Wide' && this.currentNotice.acf.frequency === 'once' && !hasSeen) {
           this.showPreview = this.currentNotice.id
          setCookie('addID', this.currentNotice.id, 12)
          return
      } 
      if(showNoticeOn === 'Site Wide' && this.currentNotice.acf.frequency === 'every') {
        this.showPreview = this.currentNotice.id
          setCookie('addID', this.currentNotice.id, 12)
          return
      }

    },
    $_getItems () {
      fetchNotifications()
      .then(res => {
        this.notices = res.data
        this.$_NewCheck()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-component {
    position: absolute;
    right: 24px;
    margin-top: 24px;
  }
  
 .custom-widget {
    padding: 12px;
    outline: none;
    min-width: 350px;
    min-height: 250px;
  }
 .custom-widget i.material-icons {
    position: relative;
    vertical-align: middle;
    line-height: 34px;
    margin-top: -2px;
  }
 .title {
    outline: none;
    padding: 6px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
  }
</style>